import React from 'react';
import {Spacer, Image, Flex, Text, ChakraProvider, theme, Link} from "@chakra-ui/react";
import ViewEventIcon from '../assets/img/view_event.svg';
import UserEventIcon from '../assets/img/user_event.svg';
import WhatsappIcon from '../assets/img/whatsapp.svg';
import { useStoreState } from 'easy-peasy';
import { useHistory } from 'react-router';
const ViewEvents  = () =>{
  const isLogin = useStoreState(state => state.isUserLogged)
  const eventDetails = useStoreState( state => state.eventDetails);
  const invite_friends_text=`Hello, here are your photos from '${eventDetails.event_name}'. Please click the link below to view your photos. ${"\n"} 
  https://memzo.ai${process.env.PUBLIC_URL}/photos/${eventDetails.event_name_org}/${eventDetails.id}`;
  const inviteUrl  = `https://api.whatsapp.com/send?text=${invite_friends_text}`;
  const history = useHistory();
  const goLoginProfile = () =>{
    history.push(`${process.env.PUBLIC_URL}/login-profile`);
  }

    return(
      <ChakraProvider theme={theme}>
      <Flex alignItems="center" justifyContent="space-between"> 
      { (!isLogin) ? (<Link   onClick={() => goLoginProfile()} key="login-showroom">
      <Flex pt="2" pb="4" mr="2" ml="6" alignItems="center">
      <Image 
        src={UserEventIcon}
        alt="User Icon"
        objectFit="cover"
        w="20px"
        h="20px"
        mr="2"/>
      <Text
        fontSize="12px"
        color="#000000"
        fontWeight={400}
        textAlign={'center'}>Login to Save Profile</Text>
      </Flex>
      <Spacer /></Link>) : 
      <Link href={`${process.env.PUBLIC_URL + "/events"}`} key="event-url">   
      <Flex pt="2" pb="4" mr="2" ml="6" alignItems="center">
        <Image
          src={ViewEventIcon}
          alt="User Icon"
          objectFit="cover"
          w="20px"
          h="20px"
          mr="2"/>
        <Text
          fontSize="12px"
          color="#000000"
          fontWeight={400}
          textAlign={'center'}>View my events</Text>
      </Flex>
      </Link>}   

      <Link href={inviteUrl} key="invite-url">   
      <Flex pt="2" pb="4" pr="5" alignItems="center">
        <Image
          src={WhatsappIcon}
          alt="User Icon"
          objectFit="cover"
          w="20px"
          h="20px"
          mr="2"/>
        <Text
          fontSize="12px"
          color="#000000"
          fontWeight={400}
          textAlign={'center'}>Invite Friends to Event</Text>
      </Flex>
      </Link>
    </Flex>
    </ChakraProvider>
)}
export default ViewEvents ;
